
import {setGetCashbackListAction} from '../action';
import { getCashback } from '../api/getCashback';

export const setGetCashback = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCashback(params);

            if (data.status === 'success') {
                dispatch(setGetCashbackListAction({
                    data: data.data,
                    countPage: data.allPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}